// Centralized conversion factors: KBBL -> MJ_LHV
export const MJ_PER_KBBL: Record<string, number> = {
  Gasoline: 5262479.63,
  Kerosene: 5675846.61,
  Diesel: 5834833.91,
  "Fuel Oil": 6295897.08,
  LPG: 3775277.58,
  FAME: 5263751.53,
  Ethanol: 3383122.55,
  HVO: 5456449.59,
};
